import { useEffect, useState } from "react";
import { api, fmtTime } from "@/lib/api";

export function ActivityLog({ taskId, version }) {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get(`/tasks/${taskId}/activity`).then((r) => setItems(r.data)); }, [taskId, version]);
  return (
    <div className="p-6 max-w-3xl" data-testid="activity-log">
      <div className="eyebrow mb-4">Activity log - actions and sources</div>
      {!items.length && <p className="text-sm text-slate-500">No activity yet.</p>}
      <ol className="relative border-l border-slate-200 ml-2 space-y-5">
        {items.map((a) => (
          <li key={a.id} className="pl-5 rise">
            <span className="absolute -left-[5px] mt-1.5 w-2.5 h-2.5 rounded-full bg-white border border-sky-500/60" />
            <div className="flex items-baseline gap-3"><span className="text-sm text-slate-900">{a.action}</span><span className="num text-[10px] text-slate-500">{fmtTime(a.created_at)}</span>{a.actor && <span className="text-[10px] text-sky-700">{a.actor}</span>}</div>
            <div className="text-xs text-slate-600 mt-0.5 break-words">{a.detail}</div>
            {a.source && <div className="flex flex-wrap gap-1 mt-1">{Object.entries(a.source).flatMap(([k, v]) => (Array.isArray(v) ? v : [typeof v === "object" ? JSON.stringify(v) : v]).map((x) => <span key={`${k}-${x}`} className="num text-[10px] px-1.5 py-0.5 rounded border border-slate-200 text-slate-500">{k}: {x}</span>))}</div>}
          </li>
        ))}
      </ol>
    </div>
  );
}
